/*
 * Collection infinite scroll (Ajaxinate) + back/forward restoration.
 *
 * When a shopper scrolls a collection, opens a product, and presses Back, we put
 * them back exactly where they were — with every product they'd scrolled to still
 * loaded. Rather than re-fetching each page (slow, and it leaves you stuck on a
 * spinner), we snapshot the grid's HTML on the way out and re-inject it instantly
 * on the way back, then hand the pagination pointer to Ajaxinate so infinite
 * scroll continues from the correct next page.
 */

if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

/*
 * Storage key for this collection view.
 *
 * We strip a leading Shopify Markets locale segment (/nl, /en, /de, /fr-be, …)
 * from the path. Otherwise a Markets redirect on the way back — landing on
 * /nl/collections/x when we left from /collections/x — produces a different key,
 * so BOTH the snapshot match and the return-flag match fail and nothing gets
 * restored. The search string is kept so filtered / sorted views keep their own
 * snapshots.
 */
function stripLocale(path) {
  return path.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i, '');
}

function collectionScrollKey() {
  return 'collScroll:' + stripLocale(window.location.pathname) + window.location.search;
}

var loadedPages = 1;
var lastScrollY = 0;

var ajaxinateInstance = null;

function getProductGrid() {
  return document.querySelector('#product-grid');
}

function getPaginationEl() {
  return document.querySelector('#AjaxinatePagination');
}

function loadingIndicatorHtml() {
  var paginationEl = getPaginationEl();
  var loadingText = (paginationEl && paginationEl.dataset.text) || 'Loading';
  return (
    '<span class="collection-loading-spinner" aria-hidden="true"></span>' +
    '<span class="visually-hidden">' + loadingText + '</span>'
  );
}

/* ── Mobile card slider: sync sliders to the Model/Product toggle ── */
function syncCardSlidersToView() {
  var toggle = document.querySelector('.view-toggle-input');
  if (!toggle) return;

  var showSecond = toggle.checked; // checked = "Product" view → slide 2

  document.querySelectorAll('.card-image-slider .card-slides').forEach(function (slides) {
    slides.scrollLeft = showSecond ? slides.offsetWidth : 0;
  });
}

document.addEventListener('change', function (e) {
  if (e.target && e.target.classList && e.target.classList.contains('view-toggle-input')) {
    syncCardSlidersToView();
  }
});

/* ── Mobile card slider: dot sync ── (registered before init that can throw) */
document.addEventListener('scroll', function (e) {
  var slides = e.target;
  if (!slides.classList || !slides.classList.contains('card-slides')) return;

  var index = Math.round(slides.scrollLeft / slides.offsetWidth);
  var dots = slides.parentElement.querySelectorAll('.card-slider-dot');
  dots.forEach(function (dot, i) {
    dot.classList.toggle('active', i === index);
  });
}, true);

var advance = function advance() {
  loadedPages++;

  syncCardSlidersToView();

  if (typeof quickAddButton == 'function') {
    quickAddButton();
  }
  if (typeof initAtcBtnAddToCart == 'function') {
    initAtcBtnAddToCart();
  }
  if (typeof initSizeVariantAddToCart == 'function') {
    initSizeVariantAddToCart();
  }
  if (typeof initQuickView == 'function') {
    initQuickView();
  }
  if (typeof initQuickViewSizeSelection == 'function') {
    initQuickViewSizeSelection();
  }
  // if(typeof initProductColorSwatches == 'function'){
  //   initProductColorSwatches();
  // }

  if (typeof initializeQuickView == 'function') {
    initializeQuickView();
  }
};


function attachAjaxinate() {
  if (ajaxinateInstance && typeof ajaxinateInstance.destroy == 'function') {
    try {
      ajaxinateInstance.destroy();
    } catch (e) {}
  }
  ajaxinateInstance = new Ajaxinate({
    container: '#product-grid',
    pagination: '#AjaxinatePagination',
    loadingText: loadingIndicatorHtml(),
    callback: advance,
  });
}

function currentPageInDom() {
  var paginationEl = getPaginationEl();
  var link = paginationEl ? paginationEl.querySelector('a') : null;
  var page = link ? parseInt(link.dataset.page, 10) : NaN;
  return isNaN(page) ? 1 : page;
}


var infinitescroll = {
  scolljs: function () {
    loadedPages = currentPageInDom();
    attachAjaxinate();
  },
};

/*
 * Snapshot the currently-rendered grid (all loaded pages), the pagination
 * pointer (so infinite scroll knows the next page), the scroll position, and
 * the grid's height (reserved on restore so the scroll target isn't clamped).
 * Stored under a single rotating key so we never accumulate large HTML blobs
 * for every collection — only the one you last left is kept.
 */
function saveCollectionState() {
  var grid = getProductGrid();
  if (!grid) return;
  var pag = getPaginationEl();

  var y = window.pageYOffset || document.documentElement.scrollTop || 0;
  if (!y && lastScrollY) y = lastScrollY;
  // Never clobber a good saved position with 0. Some navigations report a
  // scroll of 0 at pagehide even though the shopper hadn't moved; if we already
  // stored a real position for this same view (e.g. captured on the product
  // click), keep it.
  if (!y) {
    var prev = readSnapshot();
    if (prev && prev.key === collectionScrollKey() && prev.scroll > 0) {
      y = prev.scroll;
    }
  }

  try {
    sessionStorage.setItem(
      'collSnapshot',
      JSON.stringify({
        key: collectionScrollKey(),
        html: grid.innerHTML,
        pagination: pag ? pag.innerHTML : '',
        scroll: y,
        gridHeight: grid.offsetHeight,
        t: Date.now(),
      })
    );
  } catch (e) {
    /* quota exceeded on a very deep scroll — skip; degrades to top-of-page */
  }
}

function readSnapshot() {
  try {
    return JSON.parse(sessionStorage.getItem('collSnapshot'));
  } catch (e) {
    return null;
  }
}

function applyScroll(target) {
  if (!target) return;
  var tries = 0;
  (function tick() {
    window.scrollTo(0, target);
    tries++;
    var current = window.pageYOffset || document.documentElement.scrollTop;
    if (Math.abs(current - target) <= 2 || tries >= 15) return;
    setTimeout(tick, 120);
  })();
}

/*
 * Instant restore: re-inject the saved grid + pagination, re-bind the card
 * behaviours, re-arm Ajaxinate from the restored pointer, then scroll.
 * No network, no spinner.
 */
function restoreCollection(snap) {
  var grid = getProductGrid();
  if (!grid) return;

  grid.innerHTML = snap.html;

  var pag = getPaginationEl();
  if (pag) pag.innerHTML = snap.pagination || '';

  // Reserve the height the grid had when we left, so the document is tall
  // enough for the scroll target immediately — before the (mostly cached)
  // product images finish decoding. Without this, scrollTo() is clamped to a
  // short page and the shopper lands at/near the top. Released once settled.
  if (snap.gridHeight) {
    grid.style.minHeight = snap.gridHeight + 'px';
  }

  advance();          // rebind quick-add / quick-view / sliders on injected cards
  attachAjaxinate();  // continue infinite scroll from the restored next-page link

  var target = snap.scroll || 0;
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      applyScroll(target);
    });
  });

  // Let the reserved height go once the real content has laid out (after the
  // applyScroll retry window). By now natural height ≈ the reserved height.
  setTimeout(function () {
    grid.style.minHeight = '';
  }, 2000);
}

function isBackForwardNavigation() {
  var entries = performance.getEntriesByType && performance.getEntriesByType('navigation');
  if (entries && entries.length) {
    return entries[0].type === 'back_forward';
  }
  return performance.navigation && performance.navigation.type === 2;
}

/*
 * A redirect on the way back (Shopify Markets re-asserting /nl, or a JS page
 * transition) can downgrade the reported nav type from "back_forward" to
 * "navigate", which would skip restoration. So we also set an explicit
 * "left this collection to a product" flag on click, and restore whenever
 * that flag matches this collection — independent of nav type. (The key is
 * locale-stripped, so this now also survives a /nl path change.)
 */
function returningToThisCollection() {
  try {
    return sessionStorage.getItem('collReturnKey') === collectionScrollKey();
  } catch (e) {
    return false;
  }
}

function shouldRestore(snap) {
  if (!snap || snap.key !== collectionScrollKey()) return false;
  // Ignore stale snapshots (older than 30 minutes) so a fresh visit from a menu
  // link never jumps the shopper down the page unexpectedly.
  if (snap.t && Date.now() - snap.t > 30 * 60 * 1000) return false;
  return returningToThisCollection() || isBackForwardNavigation();
}

function initCollection() {
  if (!getProductGrid()) return;
  var snap = readSnapshot();
  if (shouldRestore(snap)) {
    try {
      sessionStorage.removeItem('collReturnKey');
    } catch (e) {}
    restoreCollection(snap);
  } else {
    infinitescroll.scolljs();
  }
}

initCollection();

if (!window.__collectionScrollListenersBound) {
  window.__collectionScrollListenersBound = true;

  // Cheap: just remember the latest scroll position (no serialization here).
  window.addEventListener(
    'scroll',
    function () {
      lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    },
    { passive: true }
  );

  // Fires whenever the page navigates away — captures the snapshot on leave.
  window.addEventListener('pagehide', saveCollectionState);

  // Back/forward via the browser's bfcache (common on iOS Safari): the page is
  // served frozen with all products already in the DOM, initCollection() does
  // NOT re-run, and because scrollRestoration is manual the browser won't
  // restore position — so the shopper lands at the top. Re-apply the saved
  // scroll in that case only; full navigations are handled by initCollection().
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var snap = readSnapshot();
    if (snap && snap.key === collectionScrollKey() && snap.scroll > 0) {
      applyScroll(snap.scroll);
    }
  });

  // When a product link is clicked, snapshot now and flag which collection
  // we're leaving, so the return trip restores it regardless of nav type.
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
      if (!a) return;
      try {
        saveCollectionState();
        sessionStorage.setItem('collReturnKey', collectionScrollKey());
      } catch (err) {}
    },
    true
  );
}